// extracted by mini-css-extract-plugin
module.exports = {"updateWarning":"style_updateWarning__19Mmj"};